import { createAsyncThunk } from "@reduxjs/toolkit"
import { axios_api } from "../../../api/axios-api"
import { ICreateUser, IUserProfile } from "./user-profile.types"
import { IQueryParams, getSearchQuery } from "../../../common"
import { uploadSingleFileAsync } from "../../../helpers/uploadFilesAsync"
import { closeLoaderWithMessage, openLoaderWithMessage } from "../../common"
import { createAsyncThunkPostWrapper } from "../../store.wrapper"

export const GET_USER_PROFILE_BASE_URL = "/user/get-user"
const UPSERT_USER_PROFILE_BASE_URL = "/user/upsert-profile"
const UPSERT_NEW_USER_BASE_URL = "/user/upsert-user"
const UPSERT_NEW_PUBLIC_USER_BASE_URL = "/user/upsert-user-public"


export const fetchAllUsersProfileAsync = createAsyncThunk<{ data: IUserProfile[], totalRecords: number }, IQueryParams>(
    'user-profile/fetchAllUsersProfileAsync', async (queryParams: IQueryParams) => {
        const searchQuery = getSearchQuery(queryParams);
        const response = await axios_api.get(`${GET_USER_PROFILE_BASE_URL}${searchQuery}`)
        return response.data as { data: IUserProfile[], totalRecords: number }
    },
)



export const fetchSingleUserProfileAsync = createAsyncThunk<IUserProfile, string>(
    'user-profile/fetchSingleUserProfileAsync', async (uuid: string, thunkAPI) => {
        const response = await axios_api.get(`${GET_USER_PROFILE_BASE_URL}?user_uuid=${uuid}`)
        return response.data.data[0]
    },
)


interface IUpsertUserProfile extends IUserProfile {
    file: File | null,
}

export const upsertUserProfileAsync = createAsyncThunkPostWrapper<IUserProfile, IUpsertUserProfile>(
    'user-profile/upsertUserProfileAsync', async (payload: IUpsertUserProfile, thunkAPI) => {
        
        const { file, create_ts, insert_ts, ...restPayload } = payload
        if (file) {
            const path = await uploadSingleFileAsync({
                file,
                moduleName: "USER",
                asPayload: {
                    user_name: payload.first_name, // need to be discuss
                    first_name: payload.first_name,
                    file_name: file.name,
                    file_ext: file.name.split('.').pop() || "",
                }
            })
            restPayload.profile_picture = path
        }

        const response = await axios_api.post(UPSERT_USER_PROFILE_BASE_URL, payload)
        return response.data
    },
)




export const createNewUserUserAsync = createAsyncThunkPostWrapper<ICreateUser, ICreateUser>(
    'user-profile/createNewUserUserAsync', async (payload: ICreateUser, thunkAPI) => {
        const { confirmPassword, ...restPayload} = payload
        const response = await axios_api.post(UPSERT_NEW_USER_BASE_URL, restPayload)
        thunkAPI.dispatch(fetchAllUsersProfileAsync({
            page: 1,
            rowsPerPage: 10
        }))
        return response.data
    },
)




export interface IUpsertSingleUserWithCallback {
    payload: ICreateUser,
    onSuccess: (isSuccess: boolean, data?: ICreateUser) => void
}
export const createNewPublicUserUserAsync = createAsyncThunkPostWrapper<ICreateUser, IUpsertSingleUserWithCallback>(
    'user-profile/createNewPublicUserUserAsync', async ({ payload, onSuccess }, thunkAPI) => {
        const { confirmPassword, ...restPayload} = payload
        const response = await axios_api.post(UPSERT_NEW_PUBLIC_USER_BASE_URL, restPayload)
        onSuccess(true, response.data.data)
        return thunkAPI.fulfillWithValue(response.data.data)
    },
)